export default __webpack_public_path__ + "static/media/ri_global.bf69e455.svg";